import React, { useCallback, useEffect, useState } from "react";
import SideBar from "../../../components/sidebar/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import { MultiSelect } from "react-multi-select-component";
import { MultiSelect } from "react-multi-select-component";
import TopHeader from "../../../components/topheader/TopHeader";
import { createUser, updateUser } from "../../../redux/slices/userSlice";
import { toastError } from "../../../utils/reactToastify";
import MainHeader from "../../../components/mainheader/MainHeaderNew";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import { AiTwotoneDelete } from "react-icons/ai";
import { axiosInstance, REACT_APP_URL } from "../../../config";
import { fetchUsersDetails } from "../../../redux/slices/userSlice";
import { Link } from "react-router-dom";
import { FiEdit } from "react-icons/fi";

const initialState = {
  Address: "",
  City: "",
  State: "",
  PostalCode: "",
  Country: "",
};

const AddClient = ({ showHeader = true, clientData = null }) => {
  const { id } = useParams();

  const { userdetails } = useSelector((state) => state.auth);
  const { loading, userdetails: userDetails } = useSelector(
    (state) => state.user
  );
  const [addAddress, setAddAddress] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [addressData, setAddAddressData] = useState(initialState);

  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    MobNumber: "",
    MobNumberOpt: "",
    Password: "",
    status: 1,
    UserId: "",
    GSTIN: "",
  });

  const {
    Name,
    Email,
    MobNumber,
    MobNumberOpt,
    GSTIN,
    Password,
    status,
    UserId,
  } = formData;
  const { Address, City, State, PostalCode, Country } = addressData;

  useEffect(() => {
    if (id) dispatch(fetchUsersDetails(id));
  }, [id]);

  useEffect(() => {
    if (userDetails) {
      setFormData({
        Name: userDetails?.Name || "",
        Email: userDetails?.Email || "",
        MobNumber: userDetails?.MobNumber || "",
        MobNumberOpt: userDetails?.MobNumberOpt || "",
        Password: "",
        status: userDetails?.status || 1,
        UserId: userDetails?.UserId || "",
        GSTIN: userDetails?.GSTIN || "",
      });

      setAddAddress(userDetails?.Address || []);
    }
  }, [userDetails]);

  useEffect(() => {
    if (clientData) {
      setFormData({
        Name: clientData?.Name || "",
        Email: clientData?.Email || "",
        MobNumber: clientData?.MobNumber || "",
        MobNumberOpt: clientData?.MobNumberOpt || "",
        Password: "",
        status: clientData?.status || 1,
        UserId: clientData?.UserId || "",
        GSTIN: clientData?.GSTIN || "",
      });

      setAddAddress(clientData?.Address || []);
    }
  }, [clientData]);

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddressChange = (e) => {
    setAddAddressData({
      ...addressData,
      [e.target.name]: e.target.value,
    });
  };

  const getId = (arr) => {
    return arr.map((x) => x.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log('Form Data:', formData);

    const str = MobNumber.toString();

    if (str.length !== 10) {
      return toastError("Mobile number must be at least 10 digits");
    }

    let userdata = new FormData();

    userdata.append("Name", Name);
    userdata.append("Email", Email);
    userdata.append("MobNumber", MobNumber);
    userdata.append("MobNumberOpt", MobNumberOpt);
    userdata.append("Password", MobNumber);
    userdata.append("Address", JSON.stringify(addAddress));
    // userdata.append("City", City);
    // userdata.append("State", State);
    // userdata.append("PostalCode", PostalCode);
    // userdata.append("Country", Country);
    userdata.append("status", status);
    userdata.append("userRole", "661f6f770714fa34af44a5b6");
    userdata.append("UserId", userdetails._id); // Assuming no image upload for now
    userdata.append("GSTIN", GSTIN);
    if (id) {
      // console.log("id", id)
      dispatch(updateUser({ id, userdata })); // Update user
    } else if (clientData && clientData?._id) {
      dispatch(updateUser({ id: clientData?._id, userdata })); // Create user
    } else {
      dispatch(createUser(userdata)); // Create user
    }

    if (loading === "fulfilled") {
      navigate("/Client");
    }
  };

  // console.log("userdetails", userdetails._id)
  const addAddressHandler = (e) => {
    e.preventDefault();
    // setAddAddress(prev => ([{ Address, City, State, PostalCode, Country }, ...prev]))

    if (!Address || !City || !State || !PostalCode || !Country) {
      alert("Please fill in all address fields before adding.");
      return;
    }

    const newEntry = { Address, City, State, PostalCode, Country };
    setAddAddress((prev) => [newEntry, ...prev]);
    setAddAddressData(initialState);
  };

  const handleDeleteClick = (id) => {
    const answer = window.confirm("Are You Sure !");
    if (answer) {
      setAddAddress((prev) => prev.filter((_, index) => index !== id));
    }
  };

  const handleEditClick = (id) => {
    // console.log(index)
    const toEdit = addAddress[id];
    // console.log(toEdit)
    if (toEdit) {
      setAddAddressData(toEdit);
    }
    setAddAddress((prev) => prev.filter((_, index) => index !== id));
  };

  return (
    <>
      {showHeader && <StickySidebar />}
      {showHeader && <MainHeader />}

      <div
        className="container"
        style={{
          paddingTop: showHeader ? "100px" : "10px",
        }}
      >
        <h3
          className="text-center mb-4"
          style={{
            fontWeight: "bold",
            fontSize: "2rem",
            color: "rgb(71, 91, 82)",
            paddingBottom: "5px",
          }}
        >
          {showHeader ? "Update" : "Add"} Client
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Name, Email, Phone, Phone (Optional) */}
            <div className="col-md-3 mb-3">
              <label htmlFor="Name" className="form-label">
                Name
              </label>
              <input
                type="text"
                id="Name"
                name="Name"
                className="form-control"
                placeholder="Enter Name"
                value={Name}
                onChange={handleFormChange}
                required
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="Email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="Email"
                name="Email"
                className="form-control"
                placeholder="Enter Email"
                value={Email}
                onChange={handleFormChange}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="MobNumber" className="form-label">
                Phone No.
              </label>
              <input
                type="text"
                id="MobNumber"
                name="MobNumber"
                className="form-control"
                placeholder="Enter Phone No."
                maxLength="10"
                value={MobNumber}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setFormData({ ...formData, MobNumber: val });
                }}
                required
              />
            </div>

            <div className="col-md-3 mb-3">
              <label htmlFor="MobNumberOpt" className="form-label">
                Phone No. <span className="text-muted">(Optional)</span>
              </label>
              <input
                type="text"
                id="MobNumberOpt"
                name="MobNumberOpt"
                className="form-control"
                placeholder="Enter Phone No."
                maxLength="10"
                value={formData.MobNumberOpt || ""}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setFormData({ ...formData, MobNumberOpt: val });
                }}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label htmlFor="GSTIN" className="form-label">
                GSTIN
              </label>
              <input
                type="text"
                id="GSTIN"
                name="GSTIN"
                className="form-control"
                placeholder="Enter GSTIN"
                value={GSTIN}
                onChange={handleFormChange}
              />
            </div>

            <div className="row">
              {/* Address Full Width */}
              <div className="col-md-9 mb-3">
                <label htmlFor="Address" className="form-label">
                  Address
                </label>
                <input
                  type="text"
                  id="Address"
                  name="Address"
                  className="form-control"
                  placeholder="Enter Address"
                  value={Address}
                  onChange={handleAddressChange}
                />
              </div>

              {/* City, State, Postalcode, Country */}
              <div className="col-md-3 mb-3">
                <label htmlFor="City" className="form-label">
                  City
                </label>
                <input
                  type="text"
                  id="City"
                  name="City"
                  className="form-control"
                  value={City}
                  onChange={handleAddressChange}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label htmlFor="State" className="form-label">
                  State
                </label>
                <input
                  type="text"
                  id="State"
                  name="State"
                  className="form-control"
                  value={State}
                  onChange={handleAddressChange}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label htmlFor="PostalCode" className="form-label">
                  Zip / Postal code
                </label>
                <input
                  type="text"
                  id="PostalCode"
                  name="PostalCode"
                  className="form-control"
                  maxLength="6"
                  value={PostalCode}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setAddAddressData({ ...addressData, PostalCode: val });
                  }}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label htmlFor="Country" className="form-label">
                  Country
                </label>
                <input
                  type="text"
                  id="Country"
                  name="Country"
                  className="form-control"
                  value={Country}
                  onChange={handleAddressChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <button
                  type="submit"
                  className="form-control"
                  style={{
                    position: "relative",
                    top: "45%",
                    fontSize: "0.8rem",
                    backgroundColor: "rgb(25 135 84)",
                    color: "white",
                    height: "39px",
                    margin: "auto",
                    width: "154px",
                  }}
                  onClick={addAddressHandler}
                >
                  Add More Address
                </button>
              </div>
            </div>
          </div>
          <br></br>
          <div className="table-responsive" style={{ minHeight: "23vh" }}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Sr. No.</th>
                  <th scope="col">Address</th>
                  <th scope="col">City</th>
                  <th scope="col">State</th>
                  <th scope="col">Country</th>
                  <th scope="col">PostalCode</th>
                  <th scope="col" style={{ width: "15%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {addAddress &&
                  addAddress.map((p, index) => (
                    <tr key={p._id}>
                      <th scope="row">{index + 1}</th>
                      <td>{p?.Address}</td>
                      <td>{p?.City}</td>
                      <td>{p?.State}</td>
                      <td>{p?.Country}</td>
                      <td>{p?.PostalCode}</td>
                      <td>
                        <span
                          style={{
                            backgroundColor: "#198754",
                            padding: "7px",
                            borderRadius: "8px",
                            color: "#fff",
                          }}
                          onClick={() => handleEditClick(index)}
                        >
                          <FiEdit />
                        </span>
                        &nbsp;
                        <span
                          style={{
                            backgroundColor: "#dc3545",
                            padding: "7px",
                            borderRadius: "8px",
                            color: "#fff",
                          }}
                          onClick={() => handleDeleteClick(index)}
                        >
                          <AiTwotoneDelete />
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-4 mb-5 flex">
            <button
              className="btn btn-danger"
              type="button"
              style={{
                color: "#fff",
                padding: "10px 30px",
                border: "none",
                borderRadius: "6px",
                width: "120px",
                cursor: "pointer",
                fontSize: "16px",
                marginRight: "5px",
              }}
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <button
              type="submit"
              className="btn"
              style={{
                backgroundColor: "rgb(25, 135, 84)",
                color: "#fff",
                padding: "10px 30px",
                border: "none",
                borderRadius: "6px",
                width: "120px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {id ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddClient;
